import "./App.css";
import { Route, Routes } from "react-router-dom";
import SignIn from "./components/signIn/SignIn";
import Main from "./Main";
import ReportRunners from "./components/report/ReportRunners";
import ReportRunnerDetails from "./components/report/ReportRunnerDetails";
import Runner from "./components/report/Runner";
import Transactions from "./components/transactions/Transactions";
import RunningHoursEditor from "./components/report/RunningHoursEditor";

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/all-runners" element={<ReportRunners />} />
        <Route path="/all-runner-details" element={<ReportRunnerDetails />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/runner" element={<Runner />} />
        <Route path="/runner-hours" element={<RunningHoursEditor />} />
      </Routes>
    </div>
  );
}

export default App;
